// components/feature/SupportNotificationsMount.jsx
// ─────────────────────────────────────────────────────────────
// ROOT CAUSE OF "no sound, no badge" — useSupportNotifications(userId)
// (hooks/useSupportNotifications.js) is the hook that actually opens
// the "newMessageNotification" listener and drives both the sound AND
// the unread-count badge. It was never called ANYWHERE in the app —
// SupportChat.jsx only calls setSupportChatOpen() (which flips the
// open/closed flag), and FloatingSupportButton.jsx only calls
// useUnreadSupportCount() (which READS the subscriber state, but
// creates no listener of its own). With nothing ever calling
// useSupportNotifications() itself, no socket listener for
// "newMessageNotification" existed anywhere on the client — the
// backend was correctly emitting it the whole time into a void.
//
// THIS COMPONENT is the fix: a tiny, renders-nothing component whose
// only job is to call useSupportNotifications(user.userId). Mount it
// ONCE, near the root of the app — e.g. in App.jsx / your main layout
// — OUTSIDE any specific page, so it's alive regardless of which page
// the user is currently on (which is the whole point: notifications
// need to fire even when nowhere near the support UI, like the home
// page in the reported bug).
//
// USAGE — in your root layout/App component, alongside other
// always-mounted providers:
//
//   import SupportNotificationsMount from "./components/feature/SupportNotificationsMount";
//   import { useAuth } from "./context/useAuth";
//
//   function App() {
//     const { user } = useAuth();
//     return (
//       <>
//         <SupportNotificationsMount user={user} />
//         {/* ...rest of the app/routes... */}
//       </>
//     );
//   }
//
// Renders nothing — purely a mount point for the hook's side effects.
// Safe to render even when user is null/undefined (the hook's
// internal useSocket(userId) already no-ops without a userId).
// ─────────────────────────────────────────────────────────────

import { useSupportNotifications } from "../hooks/useSupportNotifications";

export default function SupportNotificationsMount({ user }) {
  useSupportNotifications(user?.userId);
  return null;
}
